import { useGT } from 'gt-react';
import { EmailData } from './email-viewer-types';
import { Card, CardContent } from '@/components/ui/card';

const labelledPropContainerStyle = 'flex gap-1';

export function EmailHeader({ emailData }: { emailData: EmailData }) {
  const gt = useGT();

  return (
    <Card>
      <CardContent className="text-base space-y-1">
        {/* Subject */}
        <div className={labelledPropContainerStyle}>
          <div className="font-semibold text-gray-600">
            {gt('Subject:', {
              context: 'email header label for the subject line',
            })}
          </div>
          <div className="text-gray-900 break-words">{emailData.subject}</div>
        </div>

        <div className={labelledPropContainerStyle}>
          <div className="font-semibold text-gray-600">
            {gt('From:', {
              context: 'email header label for the sender address',
            })}
          </div>
          <div className="text-gray-900 break-words">{emailData.from}</div>
        </div>

        <div className={labelledPropContainerStyle}>
          <div className="font-semibold text-gray-600">
            {gt('To:', {
              context: 'email header label for the recipient address',
            })}
          </div>
          <div className="text-gray-900 break-words">{emailData.to}</div>
        </div>

        {/* CC - conditional */}
        {emailData.cc && (
          <div className={labelledPropContainerStyle}>
            <div className="font-semibold text-gray-600">
              {gt('CC:', {
                context: 'email header label for carbon copy recipients',
              })}
            </div>
            <div className="text-gray-900 break-words">{emailData.cc}</div>
          </div>
        )}

        {/* Date - conditional */}
        {emailData.date && (
          <div className={labelledPropContainerStyle}>
            <div className="font-semibold text-gray-600">
              {gt('Date:', {
                context: 'email header label for when the email was sent',
              })}
            </div>
            <div className="text-gray-900 break-words">
              {new Date(emailData.date).toLocaleString()}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
